import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "topic-mapper-list-editor"
  }, [_vm._l(_vm.keyedEntries, function (row, index) {
    return _c('div', {
      key: row.uiKey,
      staticClass: "topic-mapper-list-editor__entry"
    }, [_c('div', {
      staticClass: "topic-mapper-list-editor__header"
    }, [_c(VTextField, {
      staticClass: "topic-mapper-list-editor__topic",
      attrs: {
        "value": row.entry.topic,
        "label": "Topic",
        "disabled": _vm.disabled,
        "readonly": _vm.disabled
      },
      on: {
        "input": function ($event) {
          return _vm.updateEntry(index, {
            topic: $event
          });
        }
      }
    }), _c(VSelect, {
      staticClass: "topic-mapper-list-editor__policy",
      attrs: {
        "value": row.entry.mapperErrorPolicy,
        "items": _vm.mapperErrorPolicyItems,
        "label": "Mapper error policy override",
        "clearable": "",
        "disabled": _vm.disabled,
        "readonly": _vm.disabled
      },
      on: {
        "change": function ($event) {
          return _vm.updateMapperErrorPolicy(index, $event);
        }
      }
    }), _c('core-button', {
      attrs: {
        "disabled": _vm.disabled || index === 0,
        "x-small": "",
        "prepend-icon": "fa-arrow-up",
        "title": "Move topic mapper up",
        "aria-label": "Move topic mapper up",
        "data-test": `move-topic-mapper-up-${index}`
      },
      on: {
        "click": function ($event) {
          return _vm.moveEntry(index, -1);
        }
      }
    }), _c('core-button', {
      attrs: {
        "disabled": _vm.disabled || index === _vm.entries.length - 1,
        "x-small": "",
        "prepend-icon": "fa-arrow-down",
        "title": "Move topic mapper down",
        "aria-label": "Move topic mapper down",
        "data-test": `move-topic-mapper-down-${index}`
      },
      on: {
        "click": function ($event) {
          return _vm.moveEntry(index, 1);
        }
      }
    }), _c('core-button', {
      attrs: {
        "disabled": _vm.disabled,
        "x-small": "",
        "prepend-icon": "fa-trash-alt",
        "title": "Remove topic mapper",
        "aria-label": "Remove topic mapper",
        "data-test": `remove-topic-mapper-${index}`
      },
      on: {
        "click": function ($event) {
          return _vm.removeEntry(index);
        }
      }
    })], 1), _c('mapper-config-editor', {
      attrs: {
        "value": row.entry.mapperConfig,
        "disabled": _vm.disabled
      },
      on: {
        "input": function ($event) {
          return _vm.updateEntry(index, {
            mapperConfig: $event
          });
        }
      }
    })], 1);
  }), _c('core-button', {
    attrs: {
      "disabled": _vm.disabled,
      "prepend-icon": "fa-plus",
      "data-test": "add-topic-mapper"
    },
    on: {
      "click": _vm.addEntry
    }
  }, [_vm._v("\n    Add topic mapper\n  ")])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };